import React from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import { Manage as AppdefManage } from 'cccisd-laravel-appdefs';

const env = window.cccisd.env;

function AdminManage(props) {
    let updatedProps = _cloneDeep(props);
    try {
        ['instructor', 'parent', 'child'].forEach(roleHandle => {
            if (props.verticalNav.some(n => n.handle === roleHandle) && ['local', 'qa'].includes(env.cccisdEnv)) {
                let i = updatedProps.verticalNav.findIndex(n => n.handle === roleHandle);
                let buttons =
                    updatedProps.verticalNav[i].contentConfig.tableTop.views[0].table.columns[0].renderAs.settings
                        .buttons;
                if (!buttons.some(but => but.type === 'loginAs')) {
                    buttons.push({
                        className: 'btn-xs btn-warning',
                        label: '',
                        tooltipText: 'Login As (This is only available on QA)',
                        type: 'loginAs',
                        withTooltip: true,
                    });
                }
            }
        });
    } catch (e) {
        // meh
        console.error(e);
    }

    return <AppdefManage {...updatedProps} />;
}

export default AdminManage;
